import { readLlmAccount } from "./modelProvider";

// Explicit, user-pressed connection check. It reads the redacted summary only and
// never runs on its own or as part of storing a login.
export const testConnection = async (account?: string): Promise<string> => {
  const record = await readLlmAccount(account);
  if (!record.login.present) return "No login stored";
  return `Login valid (${record.login.kind ?? "unknown"})`;
};
